export function FooterCopyright() {
  return (
    <div className="mt-8 border-t border-gray-200 pt-8">
      <p className="text-center text-gray-600">
        © {new Date().getFullYear()} Sibystock. Tous droits réservés.
      </p>
    </div>
  );
}